import { render, staticRenderFns } from "./RemoteCreate.vue?vue&type=template&id=00f4d350&scoped=true&"
import script from "./RemoteCreate.vue?vue&type=script&lang=js&"
export * from "./RemoteCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f4d350",
  null
  
)

export default component.exports